import { addDaysYmd, dayBoundsYmd, todayYmd } from '../../utils/appTimezone';

export const RDV_PAGE_SIZE = 25;

export function buildRdvListQuery({
  periodScope = 'today',
  status = '',
  type_rendez_vous = '',
  search = '',
  page = 0
} = {}) {
  const safePage = Math.max(0, parseInt(page, 10) || 0);
  const query = {
    limit: RDV_PAGE_SIZE,
    offset: safePage * RDV_PAGE_SIZE,
    ...(status ? { status } : {}),
    ...(type_rendez_vous ? { type_rendez_vous } : {}),
    ...(String(search || '').trim() ? { search: String(search).trim() } : {})
  };

  if (periodScope === 'today') {
    const { from, to } = dayBoundsYmd(todayYmd());
    return { ...query, date_from: from, date_to: to };
  }

  if (periodScope === 'week') {
    const { from } = dayBoundsYmd(todayYmd());
    const { to } = dayBoundsYmd(addDaysYmd(todayYmd(), 6));
    return { ...query, date_from: from, date_to: to };
  }

  if (periodScope === 'upcoming') {
    const { from } = dayBoundsYmd(todayYmd());
    return { ...query, date_from: from };
  }

  return query;
}

/** Filtres export CSV (sans pagination). */
export function buildRdvExportQuery({
  periodScope = 'today',
  status = '',
  type_rendez_vous = '',
  search = ''
} = {}) {
  const { limit, offset, ...rest } = buildRdvListQuery({
    periodScope,
    status,
    type_rendez_vous,
    search,
    page: 0
  });
  return rest;
}
